import { useBrandLoaderData } from "../../../../../root/rootLoader.ts";
import { getlaunchAppUrl, getDownloadAppUrl } from "./readOffline.ts";

export default function useReadOffline() {
  const brand = useBrandLoaderData();

  const downloadAppUrl = getDownloadAppUrl(brand);

  function launchApp() {
    getlaunchAppUrl(brand.DownloadOffline.protocol)
      .then((resp) => window.open(resp, "_self"))
      .catch(() => ({}));
  }

  return {
    downloadAppUrl,
    launchApp,
  };
}
